var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSounds = function SvgSounds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 111 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeWidth: 3,
    clipPath: "url(#sounds_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 111V99.508a10 10 0 0 1 2.191-6.247L42.5 83.5M12.5 61l3.408 8.52a10 10 0 0 0 5.571 5.572l28.303 11.32a10 10 0 0 0 9.714-1.284l2.222-1.667A8.2 8.2 0 0 0 65 76.898v0c0-2.176.864-4.262 2.403-5.8l.401-.402c2.31-2.31 1.678-6.205-1.244-7.666l-7.352-3.676A3.09 3.09 0 0 1 57.5 56.59v0a3.09 3.09 0 0 1 3.09-3.09h8.447A5.963 5.963 0 0 0 75 47.537v0a5.96 5.96 0 0 1 3.748-5.536l3.707-1.483a5 5 0 0 0 2.615-6.878l-9.014-18.028A10 10 0 0 1 75 11.139V3.5M87.578 71.153c4.185-4.184 4.185-10.969 0-15.153M100.156 78.731c8.37-8.37 8.37-21.94 0-30.31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sounds_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h110v120H.5z"
  })))));
};
export default SvgSounds;